export default __webpack_public_path__ + "static/media/Ren.2d3a9003.png";